//
// question with jwplayer video - player's config override
//

export function videoPlayerSetup() {

  if (document.querySelectorAll('.js-video-question, .js-video-on-complete').length !== 1) { return; }

  return setTimeout(function() {
      const videoPlayerData = document.querySelector('.js-video-question, .js-video-on-complete').dataset;
      const id = document.querySelector('.jwplayer')
          ? document.querySelector('.jwplayer').getAttribute('id')
          : undefined;
      const config = id !== undefined ? jwplayer(id).getConfig() : null;
      const isCompletePage = !!location.pathname.includes('/complete');

      if (config) {
        const offerUrlId = videoPlayerData.offer_url_id ? 'offer_url_id=' + videoPlayerData.offer_url_id : '';
        const extId = videoPlayerData.ext_id ? '&ext_id=' + videoPlayerData.ext_id : '';
        const pageDepthCount = videoPlayerData.pd ? '&pd=' + videoPlayerData.pd : '';
        const contentToken = videoPlayerData.c ? '&c=' + videoPlayerData.c : '';
        const caseId = videoPlayerData.case_id ? '&case_id=' + videoPlayerData.case_id : '';
        const qItem = Cookies.get('q_item') && !isCompletePage ? '&q_item=' + Cookies.get('q_item') : '';
        let params = offerUrlId + extId + pageDepthCount + contentToken + caseId + qItem;
        params = params.trim().replace(/^\&+|\&+$/g, '');
        const custParams = params ? '&cust_params=' + encodeURIComponent(params) : '';

        if ((typeof config.advertising !== 'undefined') && (typeof config.advertising.schedule === 'object')) {
          if (typeof config.advertising.schedule[0].tag === 'string') {
            config.advertising.schedule[0].tag = config.advertising.schedule[0].tag + custParams;
          } else if (typeof config.advertising.schedule[0].tag === 'object' && typeof config.advertising.schedule[0].tag[0] === 'string') {
            config.advertising.schedule[0].tag[0] = config.advertising.schedule[0].tag[0] + custParams;
          }
        }

        // fix jwplayer recommendation issue
        if (typeof config.playlist === 'string') {
          config.playlist = config.playlist.split('?')[0];
        } else if (typeof config.playlist === 'object' && typeof config.playlist[0].recommendations === 'string') {
          config.playlist[0].recommendations = config.playlist[0].recommendations.split('?')[0];
        }

        jwplayer(id).setup(config);
      }
    }
    , 300);
}
